import React from "react";
import { Field, Form as FinalForm } from "react-final-form";
import { connect } from "react-redux";
import { Col, Container, FormGroup, Row, Spinner } from "reactstrap";

import arrayMutators from "final-form-arrays";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.bubble.css";
import * as S from "../../constants/StringConstants";
import { IRootState } from "../../store/reducers";
import { fetchDocuments } from "../../store/reducers/documentation";
import CheckboxField from "../Form/CheckboxFieldV2/CheckboxFieldV2";
import { EmailField, Label } from "../Form/EmailField/EmailField";
import TextField from "../Form/TextFieldV2/TextFieldV2";

/** Clears a form field value */
const clear = ([name], state, { changeValue }) => {
  changeValue(state, name, () => undefined);
};

interface IMailProps extends StateProps, DispatchProps {
  inProcess: boolean;
  linkToDoc: { desktop?: string | null; mobile?: string | null };
  defaultValues: {
    defaultRecipients: Array<string>;
    ccRecipients: Array<string>;
    subject: string;
    bodyText: string;
    smsMessage?: string;
  };
  sendMail: (
    defaultRecipients: string[],
    otherRecipients: string[],
    subject: string,
    bodyText: string,
    smsMessage: string,
    sendWithoutRevision: boolean,
  ) => void;
}

interface IMailState {}

class Mail extends React.Component<IMailProps, IMailState> {
  handleValidate = values => {
    return {};
  };

  handleSubmit = values => {
    const { defaultRecipients, ccRecipients, subject, bodyText, smsMessage, sendWithoutRevision } = values;
    this.props.sendMail(defaultRecipients, ccRecipients, subject, bodyText, smsMessage, sendWithoutRevision);
  };

  isEmailAddress(email: string) {
    var pattern = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    return pattern.test(email); // returns a boolean
  }

  render() {
    const { linkToDoc } = this.props;
    const bodyTextReplace = bodyText => {
      if (linkToDoc && (linkToDoc.desktop || linkToDoc.mobile)) {
        const regex = /information you provided. /;
        const links =
          linkToDoc.desktop && linkToDoc.mobile
            ? `<a style="display: inline" href="${linkToDoc.desktop}">(desktop)</a> or <a style="display: inline" href="${linkToDoc.mobile}">(mobile)</a>`
            : !linkToDoc.mobile
              ? `<a style="display: inline" href="${linkToDoc.desktop}">(desktop)</a>`
              : `<a style="display: inline" href="${linkToDoc.mobile}">(mobile)</a>`;

        const replaceText = `information you provided.<br />Please click on the link to view your custom DI Analyzer on
          ${links}.<br/>`;

        return bodyText.replace(regex, replaceText);
      }

      return bodyText;
    };
    const { defaultValues, inProcess } = this.props;
    const initialValues = {
      ...defaultValues,
      bodyText: bodyTextReplace(defaultValues.bodyText),
      sendSMSNotification: false,
    };

    return (
      <FinalForm
        onSubmit={this.handleSubmit}
        validate={this.handleValidate}
        initialValues={initialValues}
        mutators={{
          ...arrayMutators,
          clear,
        }}>
        {formProps => {
          return (
            <form onSubmit={formProps.handleSubmit}>
              <Container className="bootsrap-container-override mail__wrap">
                <Row className="mail__default-recipients mail__fields">
                  <Col>
                    <EmailField name="defaultRecipients" label={S.DOC_DEFAULT_RECIPIENTS} />
                  </Col>
                </Row>

                <Row>
                  <Col>
                    <EmailField name="ccRecipients" label={S.DOC_OTHER_EMAIL} />
                  </Col>
                </Row>

                <Row>
                  <Col>
                    <div>
                      <Container className="bootsrap-container-override">
                        <Row>
                          <Col>
                            <TextField
                              type="text"
                              component="input"
                              name="subject"
                              id="subject"
                              label={S.DOC_SUBJECT}
                            />
                          </Col>
                        </Row>
                      </Container>
                    </div>
                  </Col>
                </Row>

                <Row>
                  <Col>
                    <Row>
                      <Col>
                        <Label>{S.DOC_BODY_TITLE}</Label>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <FormGroup>
                          <Field type="hidden" component="input" name="bodyText" id="email-body-field">
                            {({ input: { value, ...input } }) => (
                              <ReactQuill
                                value={value}
                                onChange={(newValue, delta, source) => {
                                  if (source === "user") {
                                    input.onChange(newValue);
                                  }
                                }}
                                modules={{ toolbar: false }}
                              />
                            )}
                          </Field>
                        </FormGroup>
                      </Col>
                    </Row>
                  </Col>
                </Row>

                {defaultValues.smsMessage && (
                  <Row>
                    <Col>
                      <Row>
                        <Col>
                          <TextField
                            multiline
                            type="textarea"
                            component="textarea"
                            name="smsMessage"
                            id="sms-body-field"
                            label={S.DOC_SMS_TITLE}
                          />
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                )}

                <Row>
                  <Col sm="4">
                    <CheckboxField
                      label={S.DOC_SEND_WITHOUT_REVISION}
                      name={`sendWithoutRevision`}
                      labelPosition="above"
                    />
                  </Col>
                </Row>

                <div className="buttons__wrap">
                  <div className="button-flex">
                    <div>
                      <button type="submit" className="button-v2  primary">
                        {inProcess ? <Spinner color="black" /> : S.DOC_SEND_BUTTON}
                      </button>
                    </div>
                  </div>
                </div>
              </Container>
            </form>
          );
        }}
      </FinalForm>
    );
  }
}

const mapStateToProps = (state: IRootState) => ({
  inProcess: state.documentation.inProcess,
});

const mapDispatchToProps = { fetchDocuments };

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(mapStateToProps, mapDispatchToProps)(Mail);
